/**
 * Lab endpoints for debugging (e.g. 401 session investigation).
 * Used only on lab/debug branches.
 */
import api from './api';

const LAB_AUTH_HEALTH_URL = '/lab-auth-health';

export type LabAuthHealthResponse = { ok: boolean; message?: string };

/**
 * GET /lab-auth-health - requires authenticated session.
 * Fails with 401 when session is missing or invalid.
 */
export async function labAuthHealth(): Promise<LabAuthHealthResponse> {
  return api.get<LabAuthHealthResponse>(LAB_AUTH_HEALTH_URL, undefined, {
    showErrorToast: false,
  });
}
